import { render, staticRenderFns } from "./doctors-join.vue?vue&type=template&id=18a3396d&scoped=true&"
import script from "./doctors-join.vue?vue&type=script&lang=js&"
export * from "./doctors-join.vue?vue&type=script&lang=js&"
import style0 from "./doctors-join.vue?vue&type=style&index=0&id=18a3396d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3396d",
  null
  
)

export default component.exports